import React from 'react';
//import FormItemButton from './FormItemButton';
import {CmdUpdateControlVisibleStore} from '../stores/CmdTypeStore';
import ResizeActions from '../actions/ResizeActions';


class GongqiFormItem extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state={
			visible:this.props.controlVisible,
			hideInVisible:this.props.hideInVisible
		};
		 this.unsubcribeCmdUpdateControlVisibleStore = 
		 	CmdUpdateControlVisibleStore.listen(this.onCmdUpdateControlVisible.bind(this));

	}

	onCmdUpdateControlVisible(menuItemId,formId,names,isLookup)
	{
		if(this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId
			&& this.props.formId == formId)
		{
			if(names.indexOf(this.props.xml.name) != -1){
				let nowVisible = this.state.visible;
				let finalVisible = this.props.control.getProperty_Visible_Final();
				this.setState({visible:finalVisible});
				if(this.props.control.parentControl &&this.props.control.parentControl.classAlias=="FormItemFieldGroupControl"){
					// let filedGroup = this.props.control.parentControl.getComponentInstance(this.props.control.parentControl.parentXML,isLookup);
					// this.props.control.parentControl.module.setState({})
					// this.props.control.parentControl.component.componentRefresh();
					// ResizeActions.groupRefersh(this.props.control.parentControl );
				}
	
				if(finalVisible != nowVisible)
				{
					if(nowVisible == false && finalVisible == true)
					{
						this.visibleFlaseToTrue()
					}
				}

			}
		}
	}

	visibleFlaseToTrue()
	{
		//ResizeActions.visibleFalseToTrue();
	}
};

GongqiFormItem.defaultProps = {
};

export default GongqiFormItem;


// WEBPACK FOOTER //
// ./src/formItem/GongqiFormItem.js